import React from 'react';
import { Upload } from 'antd';

interface FileFieldProps {
  fileList?: any[];
  onChange?: (info: any) => void;
  [key: string]: any;
}

export const FileField: React.FC<FileFieldProps> = ({
  fileList = [],
  onChange,
  ...props
}) => {
  return <Upload fileList={fileList} onChange={onChange} {...props} />;
};
